<template>
  <div class="page" v-loading="loading" element-loading-text="系统加载中...">
    <div v-show="!loading">
      <f-header @success="getAuth" />
      <div v-if="false" class="banner"></div>
      <div v-if="false" class="p-intro">
        <div class="s-tt">鹰眼平台</div>
        <div class="tt">鹰眼看乡村-全景数字化治理平台</div>
        <div class="desc">
          <p>“鹰眼看乡村”品牌作为环境监测数字化治理服务应用领域的领跑者，由微影邦影视科技</p>
          <p>为协同“人居环境”与“河长巡河”工作，基于无人机智慧复飞复拍与全景视觉技术手段而</p>
          <p>打造的一款360度全景动态智慧监管系统。</p>
        </div>
      </div>
      <div v-if="project.length" class="project-list">
        <div v-for="item in project" :key="item.web" class="item" @click="enterProject(`${baseUrl}/${item.alias}/`)">
          <el-image class="cover" :src="item.img" />
          <div class="info">
            <div class="name">{{ item.name }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="link"></div>
          </div>
        </div>
      </div>
      <div v-else class="project-list-placeholder">暂无权限，请联系系统管理员分配权限</div>
      <div class="footer">Copyright © 2013-2021 微影邦 版权所有 苏ICP备18020507号 0512-36881897️</div>
    </div>
  </div>
</template>

<script>
import fHeader from '../components/yy-header';
import api from '@/api';
import config from '../../../config';

const project = [
  {
    web: 2,
    name: '人居环境',
    alias: 'rj',
    img: 'https://vybbasevr.vyb.cn/yy-rj6.png',
    desc: '鹰眼人居环境智慧管控系统，是全方位无死角全景拍摄技术是党政领导、部门负责人和村居干部之间围绕现场信息的共享平台，是一个统一、精确、高效的协同治理办公系统。',
  },
	{
		web: 11,
		name: '违建管控',
		alias: 'wj',
		img: 'https://vybbasevr.vyb.cn/yy-wj.png',
		desc: '鹰眼违建智慧管控系统，是违建管控，减存量、控增量，及时取证，AI识别，违建管控的最佳应用',
	},
  {
    web: 10,
    name: '河长巡河',
    alias: 'xh',
    img: 'https://vybbasevr.vyb.cn/yy-xh3.png',
    desc: '河湖全景动态监控专家，国内首创鹰眼巡河智慧管控系统是一款SaaS环境监测治理服务应用，该系统基于无人机复飞复拍与全景视觉技术手段，实现360度的超广视域、超高分辨率、全景空间现实影像。',
  },

];

export default {
  components: { fHeader },

  data() {
    return {
      loading: true,
      project: [],
      baseUrl:window.location.origin
    };
  },

  methods: {
    async getAuth() {
      try {
        let res = await api.works.getAuth();
        this.project = project.filter((item) => this.hasAuth(item.web, res.data));
        if (this.project.length == 1) {
          window.location.replace(`${config.API_BASE}/${this.project[0].alias}/`);
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    hasAuth(clientType, list) {
      return list.filter((item) => item.client_type == clientType)[0].has_auth == 1;
    },

    enterProject(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}

.banner {
  height: 640px;
  background: url('https://vybbasevr.vyb.cn/yy-banner-bg.png?a=1') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
  position: relative;
}

.container {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}

.p-intro {
  background: #fff;
  height: 300px;
  width: 2000px;
  position: relative;
  left: 50%;
  top: -150px;
  transform: translateX(-600px);
  box-shadow: 0 8px 23px 0 rgba(29, 92, 229, 0.1);
  padding: 36px 0 0 62px;
  box-sizing: border-box;
}

.p-intro .s-tt {
  width: 200px;
  height: 200px;
  position: absolute;
  left: 1000px;
  top: -50px;
  background: #1772ef;
  color: #fff;
  font-size: 24px;
  padding: 30px;
  box-sizing: border-box;
}

.p-intro .tt {
  font-size: 32px;
  font-weight: bold;
  position: relative;
  margin-bottom: 40px;
}

.p-intro .tt:after {
  content: '';
  height: 3px;
  width: 100px;
  position: absolute;
  left: 0;
  bottom: -14px;
  background: #1772ef;
}

.p-intro .desc {
  font-size: 17px;
  line-height: 2.5;
  letter-spacing: 1px;
}

.project-list {
  width: 1200px;
  margin: 130px auto 0;
  padding-bottom: 80px;
}

.project-list .item {
  height: 300px;
  margin-top: 40px;
  display: flex;
  background: #fff;
  cursor: pointer;
}

.project-list .item .cover {
  height: 300px;
  width: 560px;
}

.project-list .item .info {
  flex: 1;
  padding:0 72px 0 50px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.project-list .item .name {
  font-size: 28px;
  margin-top: -20px;
}

.project-list .item .desc {
  margin: 20px 0;
  line-height: 2;
  font-size: 16px;
  color: #999999;
}

.project-list .item .link {
  display: block;
  width: 56px;
  height: 56px;
  background: #1772ef;
  background-image: url('../../assets/images-front/arrow-right.png');
  background-repeat: no-repeat;
  background-position: center center;
  float: right;
  position: absolute;
  right: 50px;
  bottom: 20px;
}

.project-list .item:nth-child(2n) {
  flex-direction: row-reverse;
}

.project-list-placeholder {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 140px;
}
.footer {
  display: flex;
  align-items: center;
  color: #fff;
  background: #171b61;
  height: 123px;
  font-size: 14px;
  justify-content: center;
  letter-spacing: 1px;
}
</style>
